/**
 * Application configuration
 * Centralizes environment variables and configuration settings
 */
export const config = {
  // PostHog configuration
  posthogApiKey:
    import.meta.env.VITE_POSTHOG_API_KEY ||
    'phc_g0mBLfg4BpsDBxuIIdSjSQz3OjzLD9Voi4uHh6K2nZ',
  posthogHost: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
  environment: import.meta.env.MODE || 'development',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
};
